// A new project's DSM can't be seeded from a template at create time: the DSM
// backend stamps every write to the project in the auth token, and the app has
// no token for the just-created project yet. So we record the intent here and
// seed on the first visit to that project's Design Scope page, where the
// project-scoped token is available. Keyed projectId -> templateId; consumed
// once and only cleared after the seed succeeds, so a failed seed retries.

const KEY = "dsm:pendingTemplateSeed";

function readAll(): Record<string, string> {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "{}");
  } catch {
    return {};
  }
}

function writeAll(map: Record<string, string>): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(map));
  } catch {
    // storage unavailable (private mode / quota) — seeding just won't happen
  }
}

export function setPendingTemplateSeed(
  projectId: string,
  templateId: string
): void {
  const map = readAll();
  map[projectId] = templateId;
  writeAll(map);
}

export function getPendingTemplateSeed(projectId: string): string | null {
  return readAll()[projectId] ?? null;
}

export function clearPendingTemplateSeed(projectId: string): void {
  const map = readAll();
  if (projectId in map) {
    delete map[projectId];
    writeAll(map);
  }
}
